// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__1TuaM","dragIcon":"SortableItem_dragIcon__kGdKT","disabled":"SortableItem_disabled__DA_SH"};